import React from 'react';
import PropTypes from 'prop-types';

import { Nav, Tab, Accordion } from 'react-bootstrap5';

import CategoryTabItem from './Widgets/CategoryTabItem';
import CategoryBodyItem from './Widgets/CategoryBodyItem';

import { saveItems } from './Storage';

export default function Topics({ topics, categories, onChange }) {
  const updateTopicStatus = (topic, status) => {
    const newTopicsList = topics.map((item) => (item.id === topic.id ? { ...item, checked: status } : item));
    saveItems(newTopicsList.filter((item) => item.checked).map((item) => item.id));
    onChange(newTopicsList);
  };
  return (
    <Tab.Container
      id="program-choose-topics"
      defaultActiveKey={`category-${categories.length > 0 ? categories[0].id : ''}`}
    >
      <Nav fill justify variant="tabs">
        {categories.map((category) => (
          <CategoryTabItem
            key={`category-${category.id}`}
            item={category}
            count={topics.filter((item) => item.checked && item.attributes.topic_category_id === category.id).length}
          />
        ))}
      </Nav>
      <Accordion
        className="choose-template"
        defaultActiveKey={`category-${categories.length > 0 ? categories[0].id : ''}`}
      >
        <Tab.Content>
          {categories.map((item) => (
            <CategoryBodyItem
              key={`category-${item.id}`}
              item={item}
              topics={topics.filter((topic) => topic.attributes.topic_category_id === item.id)}
              updateTopicStatus={updateTopicStatus}
            />
          ))}
        </Tab.Content>
      </Accordion>
    </Tab.Container>

  );
}

Topics.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
};

Topics.defaultProps = {
  topics: [],
  categories: [],
  onChange: () => {},
};
